export const validateBadNumberInput = e => e.target?.validity?.badInput;